import { type ReactNode } from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import useIsScrolled from "../../../../hooks/useIsScrolled";

type RenderActions = (params: {
  isSticky: boolean;
  hideLabelOnMobile: boolean;
}) => ReactNode;

type DetailsActionsProps = {
  title: ReactNode;
  renderActions: RenderActions;
  wrapStickyWithContainer?: boolean;
  scrollThreshold?: number;
};

const DetailsActions = ({
  title,
  renderActions,
  wrapStickyWithContainer = true,
}: DetailsActionsProps) => {
  const isScrolled = useIsScrolled();

  const renderActionItems = (isSticky: boolean) =>
    renderActions({ isSticky, hideLabelOnMobile: isSticky });

  const stickyContent = (
    <div
      className="sticky-actions-header pdl-findbar-ignore"
      data-findbar-ignore
    >
      <div className="content-actions actions-with-title d-flex gap-2">
        <div className="actions-title pdl-findbar-ignore" data-findbar-ignore>
          {title}
        </div>
        <div className="d-flex gap-2">{renderActionItems(true)}</div>
      </div>
    </div>
  );

  return (
    <>
      {isScrolled &&
        (wrapStickyWithContainer ? (
          <Container>
            <Row>
              <Col>{stickyContent}</Col>
            </Row>
          </Container>
        ) : (
          stickyContent
        ))}

      <div className="content-header">
        <div className="content-actions d-flex flex-wrap justify-content-end gap-2 mt-4">
          {renderActionItems(false)}
        </div>
      </div>
    </>
  );
};

export default DetailsActions;
